	
import { CopyrightYear, PageDefinition } from "../../../Infrastructure/PageDefinition";
import { SettingService, Watch,SettingFilter, PrepareTranslate, Component, UserService, BaseTLDetailComponent, VersionService, AxiosResponse, tlLogDebug, tlLogError } from "../../../Infrastructure/CorBase/CoreBase";
	@Component
	export default class PasswordChangeBase extends BaseTLDetailComponent {
		protected versionNumberInLoginPage: string = "";

		CopyrightYear = CopyrightYear;
		versionService: VersionService = new VersionService();
		userService: UserService = new UserService();

		isCorrectEmailValSearch = true;
		isCorrectEmailVal = true;
		vPasswordNew: boolean = true;
		vPasswordNew2: boolean = true;

		showEmail = true;

		formDataPassword = {
			userId: 0,
			isLoggedUserDetail: false,
			passwordOld: '',
			passwordNew: '',
			passwordNew2: '',
			email: '',
			code: ''
		};	

		//@ts-ignore
		@Watch('$i18n.locale')
		changeLanguageBase(value: boolean, oldValue: boolean) {
			if (this.$i18n.locale == '') {
				this.recongnizeLang();
			}
		}

		changePasswordBase() {
			this.userService.updatePassword(this.formDataPassword.userId, this.formDataPassword).then(res => {
				this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('passwordChange.changePasswordSuccess').toString());

			}).catch(error => {
				this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), error.data.errors[0]);
			})
			
		}



		labelWidth = "0";
		inputWidth = "13";
		
		settingService: SettingService = new SettingService();
		versionNumber: string = '';
		isActualVersion = false;
		languageSet = '';
		
		isTestEnvironment = false;

		prepareTranslate= new PrepareTranslate();

		disabledSendEmail() {
			var result = !this.isCorrectEmailVal || this.formDataPassword.email == '';
			return result;
		}

		disabledSetPassword() {
			var result = !this.vPasswordNew || !this.vPasswordNew2 ;
			return result;
		}

		goBack() {
			this.$router.push({ name: "Login" } );
		}

		allowChangePasswordBase() {
			this.vPasswordNew && this.vPasswordNew2;
		}

		isCorrectEmailBase(item: any) {
			this.isCorrectEmailVal = item;
		}

		isCorrectPassNewBse(value: any) {
			this.vPasswordNew = value;
		}
		isCorrectPassNewBase2(value: any) {
			this.vPasswordNew2 = value;
		}

		sendEmail() {
			this.isBusy = true;
			this.isCorrectEmailValSearch = false;
			this.userService.forgetPassword(0, this.formDataPassword).then(res => {
				this.isBusy = false;
				this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('passwordChange.emailSendPassword').toString()); 
			}).catch(error => {
				this.isCorrectEmailValSearch = true;
				this.isBusy = false;
				this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), error.data.errors[0]);
			});
		}

		getVersionNumberFromREST() {
			this.versionService.getAll().then((response) => {
				let versionNumber = response.data.version as string;
				this.isTestEnvironment = response.data.isTestingEnviroment;
				//this.showTestPage = response.data.showTestPage;
				if (versionNumber && versionNumber.length > 0) {
					this.checkVersionNumber(response.data.version);
				}
			}).catch((error) => {
				this.checkVersionNumber('no version info');
			});
		}

		checkVersionNumber(versionNumberFromRest: string) {
			let versionNumberInStore = this.$store.state.versionNumber;
			let versionNumberInREST = versionNumberFromRest;
			if (versionNumberInStore != versionNumberInREST) {
				this.$store.commit('setVersionNumber', { versionNumber: versionNumberInREST });
				// VaP - dodelana kontrola, aby se obnoveni stranky nedelalo pri kazdem prvnim zobrazeni loginpage, ale jenom kdyz bude verze aplikace v prohlizeci jina nez je na serveru
				//     - puvodni logiku (versionNumberInStore != versionNumberInREST) ponecham, aby nedoslo k nekonecnemu refreshnuti stranky, p okud nekdo zapomene zmenit cislo verze v login.vue nebo ve VersionController.cs a cisla verzi byla jina
				if (this.versionNumberInLoginPage != versionNumberInREST) {
					window.location.reload();
				}
			} else {
				this.isActualVersion = true;
			}
			this.versionNumber = versionNumberInREST;
		}





		forgetPasswordBase(){
			this.loadUserByUrl(this.$route.query.code.toString());
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}	

		loadUserByUrl(code: string) {		
			this.userService.validCode(code).then(res => {
				this.formDataPassword.userId = res.data.id;
				this.formDataPassword.code = code;
				if (res.data.errorMessage != null && res.data.errorMessage != '') {
					this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errorMessage);
				}
			}).catch(error => {
				this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), error.data.errors[0]);
			});		
		}


		controlValidCode(code: string) {
			return false;
		}

		enterPressBase(): void {
			this.showEmail ? this.sendEmail() : this.changePasswordBase();
		}

		protected recongnizeLang(): void {
			var lang = navigator.language;
			lang = lang.substr(0, 2).toUpperCase();		
			if (this.$i18n.availableLocales.indexOf(lang) != -1) {
				this.$i18n.locale = lang;
			}
			else {
				this.$i18n.locale = 'EN';
			}
			this.$store.commit('setLanguage', lang);
		}

		protected setLanguage(lang: string): void {
			this.$i18n.locale = lang;
			this.$store.commit('setLanguage', lang);
			this.languageSet = lang;
		}

		
	}

